import React from "react";

import { Row, Col } from "components/layout";
import { LoadingText } from "components/Text";

import ProcessProgress from "../ProcessProgress";
import ProcessSpeed from "../ProcessSpeed";
import TimeStat from "../TimeStat";
import EmployeesCountBadge from "../EmployeesCountBadge";
import CphStat from "../CphStats";
import { NextShiftMessage } from "../NextShift";

const UnloadManuallyView = ({
  isCalculatingTargetTime,
  progress,
  progressColor,
  isBreakTime,
  targetTime,
  currentTime,
  cphLevel,
  cphColor,
  nrOfIndividuals,
  targetCph,
  currentCph,
  totalTime,
}) => {
  return (
    <Row align="middle" style={{ height: "100%" }}>
      <Col
        offset={!isBreakTime ? 0 : 1}
        span={!isBreakTime ? 7 : 9}
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-evenly",
          alignItems: "center",
          padding: "2vw",
          borderRight: !isBreakTime ? "0.4vw solid #45494D" : 0,
        }}
      >
        <Row style={{ display: "flex", justifyContent: "center" }}>
          {!isBreakTime ? (
            <ProcessSpeed
              label="Current Speed"
              speedLevel={cphLevel}
              speedColor={cphColor}
              style={{
                width: "20vw",
                height: "15vw",
              }}
            />
          ) : null}
        </Row>
        <ProcessProgress
          label="Progress"
          progress={progress}
          progressColor={progressColor}
          style={
            !isBreakTime
              ? {
                  width: "18vw",
                  height: "18vw",
                }
              : {
                  width: "34vw",
                  height: "34vw",
                }
          }
          textStyles={
            !isBreakTime
              ? {
                  fontSize: "4vw",
                }
              : {
                  fontSize: "8vw",
                }
          }
          labelStyles={
            !isBreakTime
              ? {
                  fontSize: "2vw",
                }
              : {
                  fontSize: "4vw",
                }
          }
        />
      </Col>
      {isBreakTime ? (
        <Col
          offset={1}
          span={12}
          style={{
            height: "80%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <Row>
            <NextShiftMessage>
              <span>Waiting for</span> <br />
              <span>work to</span>
              <br />
              <span>resume</span>
            </NextShiftMessage>
          </Row>
          <Row style={{ paddingTop: "8vh" }}>
            <TimeStat
              label="Total time"
              value={totalTime}
              styles={{
                value: {
                  color: "white",
                },
              }}
            />
          </Row>
        </Col>
      ) : (
        <Col offset={1} span={!isBreakTime ? 11 : 12}>
          <Row>
            <TimeStat
              label="Target Time"
              value={
                !isCalculatingTargetTime ? (
                  targetTime
                ) : (
                  <LoadingText style={{ color: "#FFFFFF" }}>
                    Calculating
                  </LoadingText>
                )
              }
              styles={{
                value: {
                  fontSize: !isCalculatingTargetTime ? "8vw" : "5vw",
                  lineHeight: !isCalculatingTargetTime ? 1 : "1.2",
                  paddingRight: !isCalculatingTargetTime ? 0 : "3ch",
                },
              }}
            />
          </Row>
          <Row style={{ paddingTop: "8vh" }}>
            <TimeStat
              label="Your Time"
              value={currentTime}
              styles={{
                value: {
                  color: progressColor,
                },
              }}
            />
          </Row>
        </Col>
      )}
      {!isBreakTime && (
        <Col
          span={5}
          style={{
            height: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            justifyContent: "space-evenly",
            borderLeft: "0.4vw solid #45494D",
            padding: "4vw",
          }}
        >
          <Row justify="center">
            <Col>
              <EmployeesCountBadge value={nrOfIndividuals} />
            </Col>
          </Row>
          <Row>
            <Col>
              <CphStat
                label="Target CPH"
                value={targetCph}
                styles={{
                  value: {
                    fontSize: targetCph.toFixed(0).length > 3 ? "5vw" : "6vw",
                  },
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <CphStat
                label="Your CPH"
                value={currentCph}
                styles={{
                  value: {
                    color: progressColor,
                    fontSize: currentCph.toFixed(0).length > 3 ? "5vw" : "6vw",
                  },
                }}
              />
            </Col>
          </Row>
        </Col>
      )}
    </Row>
  );
};

export default UnloadManuallyView;
